document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('t4s-shop-all-btn');
  if (!btn) return;

  var handle = btn.getAttribute('data-collection-handle');

  function setLoading(isLoading) {
    btn.classList.toggle('is--loading', isLoading);
    btn.disabled = isLoading;
  }

  function fetchAllProducts(handle) {
    var perPage = 250;
    var page = 1;
    var allProducts = [];

    function fetchPage() {
      return fetch('/collections/' + handle + '/products.json?limit=' + perPage + '&page=' + page)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data.products || [];
          allProducts = allProducts.concat(products);
          if (products.length === perPage) {
            page++;
            return fetchPage();
          }
          return allProducts;
        });
    }

    return fetchPage();
  }

  function formatMoney(cents, currency) {
    return (cents / 100).toFixed(2) + ' ' + (currency || '');
  }

  function showSubtotalPopup(totalPriceCents, currency, itemCount) {
    var existing = document.getElementById('t4s-shopall-popup');
    if (existing) existing.remove();

    var popup = document.createElement('div');
    popup.id = 't4s-shopall-popup';
    popup.innerHTML =
      '<div class="t4s-shopall-popup-inner">' +
        '<p><strong>' + itemCount + '</strong> items added to cart</p>' +
        '<p>Subtotal: <strong>' + formatMoney(totalPriceCents, currency) + '</strong></p>' +
        '<div class="t4s-shopall-popup-actions">' +
          '<button id="t4s-shopall-close">Continue Shopping</button>' +
          '<a href="/cart" class="t4s-shopall-viewcart">View Cart</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(popup);

    document.getElementById('t4s-shopall-close').addEventListener('click', function () {
      popup.remove();
    });
  }

  btn.addEventListener('click', function () {
    if (!handle) return;
    setLoading(true);

    fetchAllProducts(handle)
      .then(function (products) {
        var seen = {};
        var items = [];

        products.forEach(function (product) {
          var variant = product.variants.find(function (v) { return v.available; });
          if (variant && !seen[variant.id]) {
            seen[variant.id] = true;
            items.push({ id: variant.id, quantity: 1 });
          }
        });

        if (!items.length) {
          throw new Error('No available products to add.');
        }

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (addResponse) {
        // addResponse.items is ONLY what was just added in this action
        var addedItems = addResponse.items || [];
        var itemCount = addedItems.length;
        var subtotalCents = addedItems.reduce(function (sum, item) {
          return sum + item.line_price;
        }, 0);
        var currency = addResponse.items && addResponse.items[0]
          ? (window.Shopify ? Shopify.currency.active : '')
          : '';

        setLoading(false);
        showSubtotalPopup(subtotalCents, currency, itemCount);
      })
      .catch(function (err) {
        console.error('Shop All error:', err);
        setLoading(false);
        alert('Something went wrong adding items to cart. ' + (err.message || ''));
      });
  });
});